<template>
    <div class="iframe-wrapper">
        <div class="gameBar">
            <GameHeadBar @back-click="navToback" :is-favorite="isFavorite" @add-favorite="addToFavorite" />
        </div>
        <div class="iframe-container">
            <iframe
                v-if="iframeUrl"
                ref="gameIframeRef"
                :src="iframeUrl"
                frameborder="0"
                allow="autoplay"
                scrolling="no"
                @load="onIframeLoad"
            ></iframe>
        </div>
    </div>
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    <LoadingScreen ref="loadingRef"/>
</template>
<script setup lang="ts">
import { getGameUrl } from '@/api/game'
import StatusPopup from '@/components/common/statusPopup.vue'
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import GameHeadBar from './component/gameHeadBar.vue'
import { notifyEmbeddedGameResize, toggleFavorite } from './supportScript'
import { useUserStore } from '@/stores/user'
import { useGameStore } from '@/stores/games'
import LoadingScreen from '@/components/common/loadingScreen.vue'

const router = useRouter()
const route = useRoute();
const GameType = ref<any>(route.query.game_type);
const gameMakerID = ref(route.query.game_maker);
const favId = ref<any>(route.query.fav_id)
const userStore = useUserStore()
const gameStore = useGameStore()
const isFavorite = ref(false)
const favoriteStatus = ref<any>('')
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const iframeUrl = ref("")
const loadingRef = ref()
const gameIframeRef = ref<HTMLIFrameElement>()

const navToback = () => {
    router.go(-1)
}

const onIframeLoad = () => {
    notifyEmbeddedGameResize(gameIframeRef.value)
    setTimeout(() => notifyEmbeddedGameResize(gameIframeRef.value), 200)
    setTimeout(() => notifyEmbeddedGameResize(gameIframeRef.value), 800)
}

const handleParentResize = () => {
    notifyEmbeddedGameResize(gameIframeRef.value)
}

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}

const gameUrl = () => {
    loadingRef.value.open()
    let params = {
        gameId: GameType.value,
        gameMakerId: gameMakerID.value
    }
    getGameUrl(params).then(res => {
        let resData = res?.data
        iframeUrl.value = resData?.game_url || ''
        loadingRef.value.close()
    }).catch(err => {
        showError(err);
        loadingRef.value.close()
    })
}

const addToFavorite = () => {
    toggleFavorite({
        userId: userStore.id,
        gameId: favId.value,
        currentStatus: favoriteStatus.value,
        loadingRef,
        onSuccess: (status, msg) => {
            favoriteStatus.value = status
            isFavorite.value = favoriteStatus.value == '1' ? true : false
            gameStore.getGameGroupListData();
        },
        onError: (msg) => {
            showError(msg)
        }
    });
}

onMounted(() => {
    gameUrl()
    favoriteStatus.value = route.query?.favorite
    isFavorite.value = favoriteStatus.value == '1' ? true : false
    window.addEventListener('resize', handleParentResize)
    window.addEventListener('orientationchange', handleParentResize)
})

onBeforeUnmount(() => {
    window.removeEventListener('resize', handleParentResize)
    window.removeEventListener('orientationchange', handleParentResize)
})
</script>
<style scoped>
.iframe-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    height: 100dvh;
    overflow: hidden;
    margin: 0;
    padding: 0;
    z-index: 9999;
    background: #000;
    display: flex;
    flex-direction: column;
}

.gameBar {
    flex-shrink: 0;
    width: 100%;
    z-index: 2;
}

.iframe-container {
    flex: 1;
    min-height: 0;
    width: 100%;
    overflow: hidden;
    position: relative;
    background: #333;
}

.iframe-container iframe {
    display: block;
    width: 100%;
    height: 100%;
    border: none;
}
</style>
